<div class="entities-success-container">
    <img src="../../../assets/images/Illustration group.svg"/>
    <div class="paragraph">
        <span>{{'Ahora tenemos que analizar tu solicitud' | translate}}</span>
        <span>{{'Nos pondremos en contacto contigo en las próximas 48 horas laborables a través de tu email con el resultado de tu solicitud.' | translate}}</span>
    </div>
    <div class="data">
        <span>{{'Tus datos de contacto' | translate}}</span>
        <div class="banner">
            <div class="item">
                <span class="label">{{'Email' | translate}}</span>
                <span class="value">cl***********o&#64;gmail.com</span>
            </div>
            <div class="item mid">
                <span class="label">{{'Teléfono' | translate}}</span>
                <span class="value">+34 ******** 666</span>
            </div>
            <div class="item-link" (click)="modify()">
                <span class="link">Modificar</span>
            </div>
        </div>
    </div>
    <button class="primary">
        <span>{{'Ir a posición Global' | translate}}</span>
    </button>
</div>
